import SlideShow from './SlideShow';

export default SlideShow;
